<template>
  <section>
    <top-menu />

    <div class="page-content">
      <left-menu
        ref="leftMenu"
      />
      <div class="content-wrapper overflow-y-auto">
        <header-content />
        <div class="content p-0">
          <slot />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TopMenu from "./template/TopMenu";
import LeftMenu from "./template/LeftMenu";
import HeaderContent from "./template/HeaderContent";
import { mapGetters } from "vuex";
import { IS_LOGGED_IN, USER } from "@/vuex-store/types";

export default {
  components: {
    TopMenu,
    LeftMenu,
    HeaderContent,
  },
  data() {
    return {
      showLeft: false,
    };
  },

  computed: {
    ...mapGetters({
      isLoggedIn: IS_LOGGED_IN,
      user: USER,
    }),
  },

  watch: {
    isLoggedIn(isLoggedIn) {
      if (!isLoggedIn) {
        this.$router.push("/login");
      }
    },
  },

  methods: {
    toggleLeftMenu() {
      this.showLeft = !this.showLeft;
    },
  },
};
</script>

<style scoped>
.page-content {
  height: calc(100vh - 48px) !important;
}

.content-wrapper {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/backoffice/layout/BackofficeLayout.vue